// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mhueyhbocfmzyegvbcvs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1odWV5aGJvY2ZtenllZ3ZiY3ZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA4NjUwMjEsImV4cCI6MjA2NjQ0MTAyMX0.QAMpqsC6Uln0BnCcid2Ntpo06QiagypuMfUQnu5u6xY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});